"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Message = function Message(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,2 C20.6568542,2 22,3.34314575 22,5 L22,5 L22,15 C22,16.6568542 20.6568542,18 19,18 L19,18 L7.414,18 L3.70710678,21.7071068 C3.1045317,22.3096819 2.09281919,21.9276677 2.00598327,21.1136309 L2.00598327,21.1136309 L2,21 L2,5 C2,3.34314575 3.34314575,2 5,2 L5,2 Z M19,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,5 L4,18.585 L6.29289322,16.2928932 C6.44917353,16.1366129 6.65185492,16.0374017 6.86855602,16.0086724 L6.86855602,16.0086724 L7,16 L19,16 C19.5522847,16 20,15.5522847 20,15 L20,15 L20,5 C20,4.44771525 19.5522847,4 19,4 L19,4 Z M16.5,10.5 C16.7761424,10.5 17,10.7238576 17,11 C17,11.2454599 16.8231248,11.4496084 16.5898756,11.4919443 L16.5,11.5 L7.5,11.5 C7.22385763,11.5 7,11.2761424 7,11 C7,10.7545401 7.17687516,10.5503916 7.41012437,10.5080557 L7.5,10.5 L16.5,10.5 Z M16.5,7 C16.7761424,7 17,7.22385763 17,7.5 C17,7.74545989 16.8231248,7.94960837 16.5898756,7.99194433 L16.5,8 L7.5,8 C7.22385763,8 7,7.77614237 7,7.5 C7,7.25454011 7.17687516,7.05039163 7.41012437,7.00805567 L7.5,7 L16.5,7 Z"
  }));
};

exports.Message = Message;